export function inspectionEventsFromNative(datas){
    let inspectionEvents = [];

    if(datas.length>0) datas.map((data)=>{
        let inspectionEvent = {}
        let inspection = {};
        let model = {};
        let modelCategory = {};
        let inspectionStatus = {};
        let user = {}
        let manufacturingSite = {}
        inspectionEvent.id = data[0]
        inspectionEvent.serialCode = data[2]
        inspectionEvent.customer_order_no = data[3]
        inspectionEvent.productSKU=data[4]
        inspectionEvent.productName=data[5]
        inspectionEvent.performerName=data[9]
        inspectionEvent.performerRole=data[10]
        inspectionEvent.created = data[13]

        modelCategory.name = data[8]

        model.id = data[6]
        model.systemType = data[7]
        model.modelCategory = modelCategory

        inspection.reference = data[1]
        inspection.model = model

        user.id = data[14]
        user.firstname = data[15]
        user.lastname = data[16]
        user.fullname = data[15]+" "+data[16]
        manufacturingSite.id = data[17]
        manufacturingSite.name = data[18]
        user.manufacturingSite = manufacturingSite

        inspectionStatus.name = data[11]
        inspectionStatus.label = data[12]

        inspectionEvent.inspection = inspection
        inspectionEvent.inspectionStatus = inspectionStatus
        if (data[13]){
            inspectionEvent.user = user
        }
        inspectionEvents.push(inspectionEvent)
    })

    return inspectionEvents;

}